import router from '../../router'
import {allowOnlyAuthorized} from '../../router/routeGuards'

import Projects from './Projects.vue'
import AppHeader from '../../components/layout/Header'

// Setup routes
export default () => {
  router.addRoutes([
    {
      path: '/projects',
      name: 'projects',
      components: {
        default: Projects,
        header: AppHeader
      },
      meta: {
        title: 'projects'
      },
      beforeEnter: allowOnlyAuthorized()
    }
  ])
}
